module.exports = __webpack_public_path__ + "static/media/proplan.acd522ff.svg";